<template>
  <filter-bar>
    <div
      class="md-layout-item md-layout md-size-15 md-medium-size-35 md-small-size-25 md-xsmall-size-100"
    >
      <div class="md-layout-item md-layout md-size-100">
        <md-field :class="validationClass('fromDate')">
          <label for="dateOccurred">
            <md-icon>calendar_today</md-icon>
            {{ filters.fromDate ? "" : "Desde" }}
          </label>
          <datetime
            v-model="filters.fromDate"
            data-vv-name="fromDate"
            v-validate="'required'"
            input-style="border: none; outline:none; width: 100%"
            type="date"
            input-class="Object"
            :min-datetime="minDate"
            title="Desde"
            value-zone="America/Mexico_City"
            :phrases="{ ok: '', cancel: '' }"
            auto
          ></datetime>
          <md-button class="md-info md-simple md-just-icon" @click="filters.fromDate = ''">
            <md-icon>close</md-icon>
          </md-button>
        </md-field>
      </div>
    </div>

    <div
      class="md-layout-item md-layout md-size-15 md-medium-size-35 md-small-size-25 md-xsmall-size-100"
    >
      <div class="md-layout-item md-layout md-size-100">
        <md-field :class="validationClass('toDate')">
          <label for="toDate">
            <md-icon>calendar_today</md-icon>
            {{ filters.toDate ? "" : "Hasta" }}
          </label>
          <datetime
            data-vv-name="toDate"
            v-validate="requireToDate ? 'required' : ''"
            input-style="border: none; outline:none; width: 100%"
            type="date"
            input-class="Object"
            title="Hasta"
            value-zone="America/Mexico_City"
            v-model="filters.toDate"
            :phrases="{ ok: '', cancel: '' }"
            auto
          ></datetime>
          <md-button class="md-info md-simple md-just-icon" @click="filters.toDate = ''">
            <md-icon>close</md-icon>
          </md-button>
        </md-field>
      </div>
    </div>

    <div
      class="md-layout-item md-layout md-size-20 md-medium-size-35 md-small-size-25 md-xsmall-size-100"
      v-if="useReviFilter"
    >
      <md-field :class="validationClass('revi')" md-clearable>
        <label>Residente</label>
        <md-select v-model="filters.revi" data-vv-name="revi" v-validate="''">
          <md-option :value="0">Todas</md-option>
          <md-option v-for="revi in revis" :key="revi.id" :value="revi.id">{{ revi.name }}</md-option>
        </md-select>
      </md-field>
    </div>

    <div
      class="md-layout-item md-layout md-size-20 md-medium-size-35 md-small-size-25 md-xsmall-size-100"
      v-if="useHighwayFilter"
    >
      <md-field :class="validationClass('highway')" md-clearable>
        <label>Autopista</label>
        <md-select
          :multiple="multipleHighway"
          v-model="filters.highway"
          data-vv-name="highway"
          v-validate="''"
        >
          <md-option :value="0" v-if="!multipleHighway">Todas</md-option>
          <md-option
            v-for="highway in highways"
            :key="highway.id"
            :value="highway.id"
          >{{ highway.name }}</md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-10 md-layout md-alignment-center-center">
      <md-button
        @click="reload"
        class="md-info md-simple reload-button"
        :disabled="!reloadEnabled && (!validState || !valueChanged)"
      >
        <md-icon class="md-info md-size-2x" :class="replayClass">replay</md-icon>Recargar
      </md-button>
    </div>
  </filter-bar>
</template>

<script>
import { Slider, Collapse } from "@/components";
import catalogService from "../../services/catalog";
import jbUserService from "../../services/user";
import FilterBar from "@/components/FilterBar";
import moment from "moment";

export default {
  components: {
    Slider,
    Collapse,
    FilterBar,
  },

  data() {
    return {
      filters: {
        fromDate: "",
        toDate: "",
        highway: null,
        revi: null,
      },
      loading: false,
      highways: [],
      revis: [],
    };
  },

  computed: {
    validState() {
      const { requireToDate } = this;
      const { fromDate, toDate } = this.filters;

      return fromDate !== "" && !!fromDate && (!requireToDate || toDate);
    },
    replayClass() {
      if (this.loading) {
        return ["rotating"];
      }
      return "";
    },
    valueChanged() {
      const { fromDate, toDate, highway, revi } = this.filters;
      const {
        fromDate: oldFromDate,
        toDate: oldToDate,
        highway: oldHighway,
        revi: oldRevi,
      } = this.value;

      return (
        fromDate !== oldFromDate ||
        toDate !== oldToDate ||
        highway !== oldHighway ||
        revi !== oldRevi
      );
    },
  },

  mounted() {
    this.watchDates();
  },

  props: {
    value: {
      fromDate: {
        type: Date,
        default: moment().subtract(15, "days").format("YYYY-MM-DD"),
      },
      toDate: {
        type: Date,
      },
    },
    minDate: {
      type: String,
    },
    source: {
      type: Array,
    },
    useHighwayFilter: {
      type: Boolean,
      default: true,
    },
    useReviFilter: {
      type: Boolean,
      default: true,
    },
    requireToDate: {
      type: Boolean,
      default: false,
    },
    highwaysCatalog: {
      type: Array,
      required: false,
    },
    reviCatalog: {
      type: Array,
      required: false,
    },
    multipleHighway: {
      type: Boolean,
      default: false,
    },
    reloadEnabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    reload() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 1000);

      const { multipleHighway, filters } = this;

      // patch because md-select adds an empty value on deselection
      const filtersValues = {
        ...filters,
        highway: !multipleHighway
          ? filters.highway
          : filters.highway.filter((v) => v != ""),
      };

      this.$emit("input", filtersValues);
      this.watchDates();
    },
    watchDates() {
      this.unwatchTouched();
      this.watchTouched({
        filters: ["fromDate", "toDate", "highway", "revi"],
      });
    },
  },

  watch: {
    value: {
      immediate: true,
      handler({ fromDate, toDate, highway, revi }) {
        this.filters = {
          fromDate,
          toDate,
          highway,
          revi,
        };
      },
    },
    useHighwayFilter: {
      immediate: true,
      handler(value) {
        if (value) {
          const { highwaysCatalog } = this;

          if (highwaysCatalog) {
            this.highways = highwaysCatalog;
          } else {
            catalogService
              .fetch("highway")
              .then((highways) => (this.highways = highways));
          }
        }
      },
    },
    useReviFilter: {
      immediate: true,
      handler(value) {
        if (value) {
          const { reviCatalog } = this;

          if (reviCatalog) {
            this.revis = reviCatalog;
          } else {
            jbUserService
              .fetchType("simple_revi")
              .then((revis) => (this.revis = revis));
          }
        }
      },
    },
    highwaysCatalog: {
      immediate: true,
      handler(value) {
        if (value) {
          this.highways = value;
        }
      },
    },
    reviCatalog: {
      immediate: true,
      handler(value) {
        if (value) {
          this.revi = value;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}

.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.date-label {
  top: -9px;
}

.md-button.reload-button .md-button-content i {
  font-size: 32px !important;
}

.rotating {
  transition: transform 1s ease-in-out;
  transform: rotateZ(360deg);
}

.md-field.md-valid .vdatetime {
  color: #4caf50 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Macro/Filters.vue